"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "How does Benchmark Media determine the right strategy for my brand?",
  answer: "We utilize a data-driven architectural approach, analyzing market saturation, competitor positioning, and consumer behavior. Our strategy is built on precision metrics to ensure your brand doesn't just participate, but dominates its sector."
}, {
  question: "What industries do you specialize in?",
  answer: "While our methodology is universal, we excel in high-stakes environments including fintech, enterprise SaaS, and luxury markets. We serve startups looking for rapid scale and established firms aiming to maintain their market edge."
}, {
  question: "How do you measure the success of an advertising campaign?",
  answer: "Success is measured through a multi-variate lens. We track traditional KPIs like ROAS and CPA alongside deeper brand equity metrics and market share growth, providing a comprehensive view of your investment's performance."
}, {
  question: "What is the typical engagement timeline for a consulting project?",
  answer: "Strategic planning typically spans 4 to 8 weeks, followed by execution phases. We focus on building sustainable growth frameworks rather than quick fixes, ensuring long-term brand authority and measurable results."
}, {
  question: "Does Benchmark Media handle creative execution as well as strategy?",
  answer: "Yes. Our 'Architectural Edge' philosophy extends to creative production. We bridge the gap between high-level strategic planning and high-impact visual execution to ensure brand consistency across all touchpoints."
}];
export default function FaqSection() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222902" id="common-questions" className="bg-background text-foreground w-full py-16 md:py-24">
      <div ref={ref} className={`mx-auto w-full max-w-[800px] px-4 sm:px-6 transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
        <div className="mb-12 text-center">
          <h2 className="font-default text-foreground text-3xl font-extrabold tracking-tighter md:text-5xl">
            Strategic Insights
          </h2>
          <p className="font-sans text-muted-foreground mt-4 text-base md:text-lg">
            Clarifying our methodology and the architectural precision we bring to your marketing infrastructure.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => <AccordionItem data-index={i} key={i} value={`item-${i}`} className="border-border/40">
              <AccordionTrigger className="font-default text-foreground hover:text-primary text-left text-base font-bold sm:text-xl transition-colors duration-300">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="font-mono text-muted-foreground text-sm leading-relaxed sm:text-base">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}